import { render, staticRenderFns } from "./YoutubeKeywords.vue?vue&type=template&id=178356e4"
import script from "./YoutubeKeywords.vue?vue&type=script&lang=js"
export * from "./YoutubeKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports